import {useEffect, useState} from 'react'
import {showErrorToast} from '../../../../shared/components/ToastUtils'
import {loadJobs} from '../job/Api'
import {IJobModel} from '../job/JobModel'
import {loadHrProcesses} from '../process/Api'
import {IHrProcessModel} from '../process/HrProcessModel'

/** Filtre açılır listeleri tek seferde yüklenir */
const OPTION_PAGE_SIZE = 1000

/** İlan ve süreç filtre seçenekleri */
export function useJobProcessOptions() {
  const [jobs, setJobs] = useState<IJobModel[]>([])
  const [processes, setProcesses] = useState<IHrProcessModel[]>([])

  useEffect(() => {
    Promise.all([loadJobs(0, OPTION_PAGE_SIZE), loadHrProcesses(0, OPTION_PAGE_SIZE)])
      .then(([jobResponse, processResponse]) => {
        setJobs(jobResponse.data.payload.content)
        setProcesses(processResponse.data.payload.content)
      })
      .catch(() => showErrorToast('Filtre seçenekleri yüklenemedi'))
  }, [])

  return {jobs, processes}
}
